import { createRouter, createWebHistory } from 'vue-router';


export default createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../views/Home.vue'),
      meta: {
        title: 'Senyum Dental Clinic - Quality Dental Care in Malaysia',
        description: 'Professional dental clinic offering comprehensive dental services including implants, whitening, and consultations. Expert dentists providing quality care for all your dental needs.',
        keywords: 'dental clinic, dentist Malaysia, dental implants, teeth whitening, dental consultation',
        ogTitle: 'Senyum Dental Clinic - Your Smile Matters',
        ogDescription: 'Expert dental care with modern facilities and experienced dentists. Book your consultation today.',
        ogImage: '/images/clinic/hero-image.jpg',
        ogType: 'website'
      }
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('../views/About.vue'),
      meta: {
        title: 'About Senyum Dental Clinic - Our Story & Team',
        description: 'Learn about Senyum Dental Clinic\'s mission, experienced team of dentists, and commitment to providing exceptional dental care with modern technology.',
        keywords: 'about dental clinic, dentist team, dental experience, dental technology',
        ogTitle: 'About Senyum Dental Clinic - Meet Our Expert Team',
        ogDescription: 'Discover our experienced dental professionals and state-of-the-art facilities.',
        ogImage: '/images/clinic/team.jpg',
        ogType: 'website'
      }
    },
    {
      path: '/services',
      name: 'services',
      component: () => import('../views/Services.vue'),
      meta: {
        title: 'Dental Services - Implants, Whitening & More',
        description: 'Comprehensive dental services including dental implants, teeth whitening, root canal treatment, and preventive care. Professional dental procedures with latest technology.',
        keywords: 'dental services, dental implants, teeth whitening, root canal, dental procedures',
        ogTitle: 'Professional Dental Services - Senyum Dental Clinic',
        ogDescription: 'Complete range of dental treatments from implants to whitening. Advanced dental care.',
        ogImage: '/images/services/dental-services.jpg',
        ogType: 'website'
      }
    },
    {
      path: '/panel',
      name: 'panel',
      component: () => import('../views/Panel.vue'),
      meta: {
        title: 'Insurance Panel - Accepted Dental Insurance',
        description: 'Senyum Dental Clinic accepts major dental insurance plans. Check if your insurance is accepted and get affordable dental care coverage.',
        keywords: 'dental insurance, insurance panel, accepted insurance, dental coverage',
        ogTitle: 'Dental Insurance Panel - Accepted Plans',
        ogDescription: 'Find out which dental insurance plans are accepted at Senyum Dental Clinic.',
        ogImage: '/images/insurance/insurance-panel.jpg',
        ogType: 'website'
      }
    },
    {
      path: '/services/dental-implant',
      name: 'dental-implant',
      component: () => import('../views/services/DentalImplant.vue'),
      meta: {
        title: 'Dental Implants - Permanent Tooth Replacement',
        description: 'Professional dental implant services for permanent tooth replacement. High success rate with experienced implant specialists using premium implant systems.',
        keywords: 'dental implants, tooth replacement, implant dentistry, permanent teeth',
        ogTitle: 'Dental Implants - Restore Your Smile',
        ogDescription: 'Professional dental implant treatment for permanent tooth replacement solutions.',
        ogImage: '/images/services/dental-implant.jpg',
        ogType: 'website'
      }
    },
    {
      path: '/services/teeth-whitening',
      name: 'teeth-whitening',
      component: () => import('../views/services/TeethWhitening.vue'),
      meta: {
        title: 'Professional Teeth Whitening - Brighten Your Smile',
        description: 'Professional teeth whitening services for a brighter, more confident smile. Safe and effective whitening treatments using advanced technology.',
        keywords: 'teeth whitening, dental whitening, smile brightening, cosmetic dentistry',
        ogTitle: 'Professional Teeth Whitening Services',
        ogDescription: 'Achieve a brighter, more confident smile with our professional whitening treatments.',
        ogImage: '/images/services/teeth-whitening.jpg',
        ogType: 'website'
      }
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: () => import('../components/NotFound.vue'),
      meta: {
        title: 'Page Not Found - Senyum Dental Clinic',
        description: 'The page you are looking for could not be found. Return to Senyum Dental Clinic for quality dental care services.',
        keywords: 'page not found, 404 error, dental clinic',
        ogTitle: 'Page Not Found - Senyum Dental Clinic',
        ogDescription: 'Page not found. Visit Senyum Dental Clinic for professional dental services.',
        ogType: 'website'
      }
    },
  ],
});